import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  getAcademies,
} from '../../axios/academiesRequests';
import {
  getPublishedAds,
} from '../../axios/bannerAdsRequests';
import {
  getBranches,
} from '../../axios/branchesRequests';
import {
  getHome, postHome, updateCardPrivacy, updateCardStatus,
} from '../../axios/homeRequests';
import {
  getArticles,
} from '../../axios/newsRequests';
import {
  uploadFileURL,
} from '../../axios/requests';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  getHeader,
} from '../../helperFunctions/getHeader';
import {
  uploadFile,
} from '../../helperFunctions/uploadService';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  IHomeStore, IPostSubmission, IType,
} from '../storeInterfaces/homeInterface';
import { RequestStatus } from 'mobx-store';

export class HomeStore implements IHomeStore {
  @observable homeList: IType[] = [];

  @observable articlesList: any[] = [];

  @observable branchesList: any[] = [];

  @observable academiesList: any[] = [];

  @observable adsList: any[] = [];

  @observable isLoading = false;

  @observable getHomeCardsRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getHome(countries: ICountry[]): Promise<any> {
    try {
      this.isLoading = true;
      this.getHomeCardsRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const response = await Connections.wadiDeglaAxios.httpGet(getHome, {
        ...getHeader(DefaultLanguage),
        params: {
          page: 1,
          size: 50,
          status: 'all',
          availableCountries,
        },
      });
      console.log(response);
      this.homeList = response.data;
      this.getHomeCardsRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getHomeCardsRequestStatus =RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  @action
  public async getArticles(type: 'news' | 'announcement', countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.isLoading = true;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
        type,
        status: 'published',
      };
      const config = {
        ...getHeader(langCode), params,
      };

      const articlesResponse = await Connections.wadiDeglaAxios.httpGet(getArticles, config);
      this.articlesList = articlesResponse.data;
    } catch (error) {
      console.log(error);
    } finally {
      console.log('');
      this.isLoading = false;
    }
  }

  @action
  public async getBranches(countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.isLoading = true;
      const availableCountries = convertCountriesToISOCodeString(countries);
      const params = {
        availableCountries,
        status: 'active',
      };
      const config = {
        ...getHeader(langCode), params,
      };

      const branchesResponse = await Connections.wadiDeglaAxios.httpGet(getBranches, config);
      this.branchesList = branchesResponse.data;
    } catch (error) {
      console.log(error);
    } finally {
      console.log('');
      this.isLoading = false;
    }
  }

  @action
  public async getAcademies(countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.isLoading = true;
      const countriesIsoCode = countries.map((country: ICountry) => country.isoCode);
      const availableCountries = countriesIsoCode.toString();

      const academiesResponse = await Connections.wadiDeglaAxios.httpGet(getAcademies(availableCountries, 'active'), getHeader(langCode));
      this.academiesList = academiesResponse.data;
    } catch (error) {
      console.log(error);
    } finally {
      console.log('');
      this.isLoading = false;
    }
  }

  @action
  public async getPublishedAds(countries: ICountry[], langCode: string = DefaultLanguage): Promise<any> {
    try {
      this.isLoading = true;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
        status: 'published',
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getPublishedAds, {
        ...getHeader(langCode), params,
      });
      this.adsList = response.data;
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  @action.bound
  public async postHomeCard(data: IPostSubmission): Promise<any> {
    try {
      this.isLoading = true;
      if (data.card.image) {
        data.card.imageURL = await this.uploadSingleImage([data.card.image]);
        delete data.card.image;
      }
      const response = await Connections.wadiDeglaAxios.httpPost(postHome, data);
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  @action.bound
  public async updateHomeCardPrivacy(updatedCardPrivacy: boolean, index: number): Promise<any> {
    try {
      const response = await Connections.wadiDeglaAxios.httpPut(updateCardPrivacy(this.homeList[index].cardId), {
        isPrivate: updatedCardPrivacy,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.homeList[index].isPrivate = updatedCardPrivacy;
    }
  }

  @action.bound
  public async updateHomeCardStatus(updatedCardStatus: boolean, index: number): Promise<any> {
    try {
      const response = await Connections.wadiDeglaAxios.httpPut(updateCardStatus(this.homeList[index].cardId), {
        isActive: updatedCardStatus,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.homeList[index].isActive = updatedCardStatus;
    }
  }

  private uploadSingleImage(images: any[]) {
    const promises = [];
    const allImages: any[] = [];
    for (const image of images) {
      if (image.preview) {
        promises.push(
          uploadFile(uploadFileURL, image)
            .then((res: any) => {
              allImages.push(res.data.downloadURL);
            }),
        );
      } else {
        allImages.push(image.imageUrl);
      }
    }
    return Promise.all(promises)
      .then(() => {
        console.log('done');
        return (allImages.length ? allImages[0] : null);
      }).catch((error) => {
        console.log('error');
        return (allImages.length ? allImages[0] : null);
      });
  }
}
